//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ErrorLayout',

  layout: 'default',

  props: {
    error: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    statusCode() {
      return this.error?.statusCode || 500
    },

    message() {
      switch (this.statusCode) {
        case 404:
          return `Our hummingbirds can't seem to find<br> what you're looking for.`
        default:
          return `Something's gone wrong in our nest<br class="md:hidden"> – but don't worry<br> our hummingbirds are on it!`
      }
    }
  },

  mounted() {
    if (![401, 403, 404].includes(this.statusCode)) {
      this.$rollbar.error(`[error] ${this.error.message}`, this.error)
    }
  }
}
